import React from 'react'
import '../About/About.css'
import WhyChoose from '../WhyChoose/WhyChoose'
const About = () => {
  return (
   <>
     <div className="post-a">
                <div className="overlay-a">
                    <h1 className="text-a">About Us</h1>
                    <p className='text-p-a'>Journey Beyond Borders with TripMart – Explore, Experience, Enjoy! </p>
                </div>
            </div>


            <section className="about-section-aa">
      <h1 className="about-heading-aa">About Tripmart</h1>
      <p className="about-text-aa">
        Tripmart is an online company offering online travel products and services. 
      </p>
      <p className="about-text-aa">
      More than thousands of customers have already booked their flights & holidays with us and benefited from our expertise, discovering economy, value for money and making huge savings. As a travel solution provider, we have made our mark in a crowded and opaque marketplace by delivering what our customers have asked for.
      </p>
      <p className="about-text-aa">
      We are transparent and dedicatedly working towards customers’ query. Our hugely experienced, loyal, and friendly staff truly understand the market and your needs, and our reputation has been built on long established and carefully nurtured relationships with our travel partners.
      </p>

      <div className="about-cards-aa">
  <div className="card-aa">
    <p className="card-title-aa">Why Choose Us?</p>
    <p className="card-description-aa">
      With our expertise and strong industry connections, we provide unbeatable airfares and hotel deals worldwide. Our dedicated team ensures a seamless, personalized travel experience tailored to your needs.
    </p>
  </div>
  <div className="card-aa">
    <p className="card-title-aa">Our Mission</p>
    <p className="card-description-aa">
      We are committed to maintaining the perfect balance between quality and value, fostering long-term relationships with our clients while offering transparent, reliable, and customer-focused travel services.
    </p>
  </div>
  <div className="card-aa">
    <p className="card-title-aa">Our Goals</p>
    <p className="card-description-aa">
      Our goal is to maximize value by providing the best travel deals, continuously improving services through customer feedback, and rewarding loyal clients with exceptional experiences and offers.
    </p>
  </div>
</div>

    </section>

    <div className="quote-aa">
    <h1>"Travel is the only thing you buy that makes you richer"</h1>
  </div>


  <WhyChoose/>
   </>
  )
}

export default About